











import { Component, Mixins, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import Mixin from '@/mixins/base';

const RolesModule = namespace('dashboard/roles');

@Component({
  mixins: [Mixin],
  components: {
    'delete-confirmation': DeleteConfirmation
  }
})
export default class RoleDeleteButton extends Mixins(Mixin) {
  @Prop({ required: true })
  private roleId!: number;

  @Prop({ required: true })
  private roleName!: string;

  @Prop({ type: Boolean, default: false })
  private persistent!: boolean;

  @RolesModule.Action('Remove')
  private removeRole!: (roleId: number) => Promise<void>;

  private async deleteAction(): Promise<void> {
    await this.removeRole(this.roleId);
  }
}
